<template>
  <div>
    <router-view></router-view>
    <dialog-handler-error
      :openDialog="isOpenDialog"
      :content="content"
      v-if="isEnableDialog"
    ></dialog-handler-error>
  </div>
</template>

<script>
  import DialogHandlerError from "./components/DialogHandlerError";
  import {EventBus} from "./event-bus";
  import constants from "./constants";
  import utils from "./services/utils";
  import errorMessageFilter from "./filters/errorMessageFilter";
  import authenService from "./services/authenService";
  import { initializeTlaScript } from "./utils/initializeTlaScript";

  export default {
    name: "App-main",
    components: {DialogHandlerError},
    data() {
      return {
        isOpenDialog: false,
        isEnableDialog: false,
        content: null
      };
    },
    watch: {
      isOpenDialog(newValue) {
        newValue && (this.isEnableDialog = newValue);
      },
      tenantData(newValue) {
        this.setActiveTla(newValue)
      }
    },
    computed: {
      tenantData() {
        return this.$store.getters.tenantData;
      },
    },
    async created() {
      this.registerGlobalEvent();
    },
    methods: {
      registerGlobalEvent() {
        EventBus.$on(constants.EVENT_BUS.CATCH_ERROR_RESPONSE, event =>
          this.handleGlobalError(event.error)
        );
      },

      handleGlobalError(error) {
        if (
          utils.isErrorResponseMatch(error, constants.HTTP_STATUS.UNAUTHORIZED)
        ) {
          this.handle401Error(error);
          this.isOpenDialog = true;
        } else if (
          utils.isErrorResponseMatch(error, constants.HTTP_STATUS.FORBIDDEN)
        ) {
          this.handle403Error();
          this.isOpenDialog = true;
        } else if (
          utils.isErrorResponseMatch(error, constants.HTTP_STATUS.BAD_REQUEST)
        ) {
          this.handle400Error(error);
          this.isOpenDialog = true;
        }
      },

      handle401Error(errorResponse) {
        let error = errorResponse.response.data.error;
        console.log(error);
        if (error === 'authenticate.BlacklistJwtException' || error === 'authenticate.authenHeaderRequired' || error === 'authenticate.authenHeaderInvalid'){
          authenService.saveLogoutError();
        }
        this.content = errorMessageFilter({
          errorCode: error || "error.default.401"
        });
      },

      handle403Error() {
        this.content = errorMessageFilter({errorCode: "error.default.403"});
      },

      handle400Error(errorResponse) {
        if (utils.isBussinessErrorException(errorResponse)) {
          let error = errorResponse.response.data.errors[0];
          this.content = errorMessageFilter({
            errorCode: error && error.errorCode ? error.errorCode : "unknownError"
          });
        } else {
          this.content = errorMessageFilter({errorCode: "unknownError"});
        }
      },

      async loadTlaScript() {
        try {
          initializeTlaScript()
          // Force re-render if needed
          await this.$nextTick(() => {
            // Additional logic after script loads
          })
        } catch (error) {
          console.error('Error loading TLA script:', error)
        }
      },

      async setActiveTla(tenantData){
        // Khởi tạo ở index.html vì có case dị không load đc ở lần đầu
        // Nhưng ở đây vẫn bồi cho chắc cú
        let chatIcon = document.getElementById('chat-icon');
        if(!chatIcon) {
          await this.loadTlaScript();
          chatIcon = document.getElementById('chat-icon');
        }
        if (tenantData && tenantData.isEnableTla === 'active') {
          chatIcon.className = 'chat-icon'; // Set to just "chat-icon"
        } else {
          chatIcon.className = 'chat-icon hidden'; // Add "hidden" class
        }
      },
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/App_main.vue